// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__n79lB","col":"styles_col__1KUjD"};